import React from 'react'
import styled from 'styled-components'
import { ColumnProps } from 'antd/lib/table'
import { TagCP } from 'submodules/nerit-framework-ui/common/components/tag/TagCP'
import { CollectionGridResponseDTO, CollectionGridCellResponseDTO } from 'submodules/nerit-aquatec-sdk/services/collection-control/dtos/responses/CollectionGridResponseDTO'
import { MonthColumnTP } from 'modules/collection-performance/utils/MonthRangeUtils'
import { CollectionStatusUtils } from 'modules/collection-performance/utils/CollectionStatusUtils'

/** Uma linha da grade (um ponto) com as celulas indexadas por mes. */
type CollectionRowTP = {
    key: number,
    locationCode: number,
    locationName: string,
    cellsByKey: { [monthKey: string]: CollectionGridCellResponseDTO },
}

export type OnClickCellTP = (row: CollectionRowTP, month: MonthColumnTP, cell: CollectionGridCellResponseDTO) => void

type TableStructureTP = {
    columns: Array<ColumnProps<CollectionRowTP>>,
    data: CollectionRowTP[],
}

/**
 * Monta a estrutura da grade ponto x mes (Tela 3.2).
 */
export class CollectionControlTableUtils {

    static mountTableStructure(
        grid: CollectionGridResponseDTO,
        months: MonthColumnTP[],
        onClickCell: OnClickCellTP,
    ): TableStructureTP {

        const columns: Array<ColumnProps<CollectionRowTP>> = [
            {
                title: 'Ponto',
                dataIndex: 'locationName',
                className: 'fixedColumn',
                width: 220,
            },
            ...months.map((month) => ({
                title: month.label,
                key: month.key,
                align: 'center' as const,
                width: 130,
                render: (text: string, row: CollectionRowTP) => {
                    const cell = row.cellsByKey[month.key]
                    if (!cell)
                        return null

                    return {
                        children: (
                            <CellWrapperSCP onClick={() => onClickCell(row, month, cell)}>
                                <TagCP
                                    content={CollectionStatusUtils.getLabel(cell.status)}
                                    color={CollectionStatusUtils.getColor(cell.status)}
                                    borderType={'circle'}
                                    small={true}
                                />
                                <CellHintsSCP>
                                    {cell.isAutomatic && <AutoHintSCP>auto</AutoHintSCP>}
                                    {!!cell.note && <NoteHintSCP title={cell.note}>obs.</NoteHintSCP>}
                                </CellHintsSCP>
                            </CellWrapperSCP>
                        ),
                    }
                },
            })),
        ]

        const data: CollectionRowTP[] = grid.locations.map((location) => {
            const cellsByKey: { [monthKey: string]: CollectionGridCellResponseDTO } = {}
            location.cells.forEach((cell) => {
                cellsByKey[`${cell.year}_${cell.month}`] = cell
            })

            return {
                key: location.locationCode,
                locationCode: location.locationCode,
                locationName: location.locationName,
                cellsByKey,
            }
        })

        return { columns, data }
    }

}

const CellWrapperSCP = styled.div`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
`

const CellHintsSCP = styled.div`
    display: flex;
    gap: 4px;
    min-height: 12px;
`

const AutoHintSCP = styled.span`
    font-size: 0.65rem;
    color: #8c8c8c;
    text-transform: uppercase;
`

const NoteHintSCP = styled.span`
    font-size: 0.65rem;
    color: #1890ff;
    text-transform: uppercase;
`
